import axios from "axios";
import {
  GET_SETTINGS,
  CREATE_SETTINGS,
  UPDATE_SETTING,
  GET_PROFILE,
  SETTING_ERROR,
} from "./types";

// Create initial user settings
export const getCurrentSettings = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/settings`);

    dispatch({
      type: GET_SETTINGS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SETTING_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create initial user settings
export const getSettings = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/settings/${channelid}`);

    dispatch({
      type: CREATE_SETTINGS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SETTING_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Update a setting
export const updateSetting = (e) => async (dispatch) => {
  const formData = new FormData();
  formData.append("setting", JSON.stringify(e));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.put(`/api/settings`, formData, config);

    dispatch({
      type: UPDATE_SETTING,
      payload: res.data.updatedSettings,
    });

    dispatch({
      type: GET_PROFILE,
      payload: res.data.profile,
    });
  } catch (err) {
    dispatch({
      type: SETTING_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
